var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTextSize(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 200.25,
    height: 139.977,
    viewBox: "0 0 200.25 139.977",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1",
    "data-name": "Rectangle 1",
    width: 200.25,
    height: 139.977,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_3",
    "data-name": "Group 3",
    transform: "translate(-860 -471)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2",
    "data-name": "Group 2",
    transform: "translate(860 471)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1",
    "data-name": "Group 1",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1",
    "data-name": "Path 1",
    d: "M110.381,0H10.353A10.353,10.353,0,0,0,0,10.353V29.531a10.353,10.353,0,0,0,20.706,0V20.706H50.014v98.258H40.226a10.353,10.353,0,1,0,0,20.706H80.508a10.353,10.353,0,0,0,0-20.706H70.72V20.706h29.308v8.825a10.353,10.353,0,0,0,20.706,0V10.353A10.353,10.353,0,0,0,110.381,0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2",
    "data-name": "Path 2",
    d: "M189.9,59.354h-78.01a10.353,10.353,0,0,0-10.353,10.353V84.882a10.353,10.353,0,0,0,20.706,0V80.06h18.3v39.211h-3.783a10.353,10.353,0,0,0,0,20.706h28.272a10.353,10.353,0,0,0,0-20.706h-3.783V80.06h18.3v4.822a10.353,10.353,0,0,0,20.706,0V69.707A10.353,10.353,0,0,0,189.9,59.354"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTextSize);
export default __webpack_public_path__ + "static/media/text-size.cb374edd7c7d853d81655d5441fe434e.svg";
export { ForwardRef as ReactComponent };